import React from 'react'
import { Label, Paragraph } from 'atoms/Texts'
import { NotifUnreadDot, NotifTitleSpan } from './styles'
import moment from 'moment'

export const notifTitleFormatter = (cell, row, rowIndex, formatExtraData) => {
  return (
    <NotifTitleSpan>
      <Label color={'#ff7300'}>
        {row.title}
      </Label>
    </NotifTitleSpan>
  )
}

export const notifBodyFormatter = (cell, row, rowIndex, formatExtraData) => {
  return (
    <NotifTitleSpan>
      <Paragraph>
        {row.body}
      </Paragraph>
      {!row.readAt &&
        <NotifUnreadDot />
      }
    </NotifTitleSpan>
  )
}

export const notifDateFormatter = (cell, row, rowIndex, formatExtraData) => {
  return (
    <span>
      <Label float={'right'} lineheight={'12px'} size={'10px'} color={'#00b4a5'} mb={'0'}>
        {moment(row.createdAt).fromNow()}
      </Label>
    </span>
  )
}
